import { ResourceDetector, ResourceDetectionConfig, DetectedResource } from '@opentelemetry/resources';

/**
 * 业务专属资源探测器
 * 负责从环境变量中提取低代码平台特有的元数据 (Tenant, App, Env)
 */
export class PlatformDetector implements ResourceDetector {
  
  /**
   * 实现 detect 接口
   * @param config 探测配置 (可选)
   */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
  detect(_config?: ResourceDetectionConfig): DetectedResource {
    // 1. 从环境变量读取平台级资源字段
    const attributes: Record<string, string | number | boolean> = {};

    // 2. 清洗数据：移除 undefined/null/空字符串
    const cleanAttributes = Object.entries(attributes).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as Record<string, string | number | boolean>);

    // 3. 返回 Resource 对象
    return {
      attributes: cleanAttributes,
    }
  }
}

export const lowCodeDetector = new PlatformDetector();